<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1339.999 -119)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1339.999 119)" />
			<path d="M34,17.125H11.181L21.662,6.644,19,4,4,19,19,34l2.644-2.644L11.181,20.875H34Z"
				transform="translate(1343.499 122.5)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'b-icon-arrow-back',
		components: {},
		computed: {},
		props: {},
	};
</script>

<style scoped lang="scss">
	path.a {
		fill: none;
	}
</style>

<docs>
	IconArrowBack

	```js
	<b-icon-arrow-back />
	```
</docs>